import React, { createContext, useState, ReactNode } from 'react';
import {
	ElementMenuItemListProps,
	ItemFromElementMenuProps
} from 'types/ElementMenuProps';

interface ItensMenuContextProps {
	isLoad: boolean;
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>;
	idFatherElement: string;
	setIdFatherElement: React.Dispatch<React.SetStateAction<string>>;
	isFormOpen: boolean;
	setIsFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
	elementMenuItens: ElementMenuItemListProps[];
	setElementMenuItens: React.Dispatch<
		React.SetStateAction<ElementMenuItemListProps[]>
	>;
	itensFromElement: ItemFromElementMenuProps[];
	setItensFromElement: React.Dispatch<
		React.SetStateAction<ItemFromElementMenuProps[]>
	>;
	itemFromElementToEdit: ItemFromElementMenuProps | null;
	setItemFromElementToEdit: React.Dispatch<
		React.SetStateAction<ItemFromElementMenuProps | null>
	>;
}

const ItensMenuContext = createContext<ItensMenuContextProps>({
	elementMenuItens: [],
	setElementMenuItens: () => {},
	idFatherElement: '',
	setIdFatherElement: () => {},
	isLoad: false,
	setIsLoad: () => {},
	isFormOpen: false,
	setIsFormOpen: () => {},
	itensFromElement: [],
	setItensFromElement: () => {},
	itemFromElementToEdit: null,
	setItemFromElementToEdit: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function ItensMenuProvider({ children }: ContextProps) {
	const [isLoad, setIsLoad] = useState<boolean>(false);
	const [isFormOpen, setIsFormOpen] = useState<boolean>(false);
	const [elementMenuItens, setElementMenuItens] = useState<
		ElementMenuItemListProps[]
	>([]);
	const [itensFromElement, setItensFromElement] = useState<
		ItemFromElementMenuProps[]
	>([]);
	const [itemFromElementToEdit, setItemFromElementToEdit] =
		useState<ItemFromElementMenuProps | null>(null);
	const [idFatherElement, setIdFatherElement] = useState('');

	return (
		<ItensMenuContext.Provider
			value={{
				idFatherElement,
				setIdFatherElement,
				isLoad,
				setIsLoad,
				isFormOpen,
				setIsFormOpen,
				elementMenuItens,
				setElementMenuItens,
				itensFromElement,
				setItensFromElement,
				itemFromElementToEdit,
				setItemFromElementToEdit
			}}
		>
			{children}
		</ItensMenuContext.Provider>
	);
}

export default ItensMenuContext;
